export class FlowData {
    client_id = '';
    response_type = '';
    redirect_uri = '';
    scope = '';
    state = '';
}